import { Report } from './types'

export const INSIGHTS_LOAD = 'INSIGHTS_LOAD'
export interface InsightsLoadAction {
  type: typeof INSIGHTS_LOAD
  accountId: string
  startDate?: string
  endDate?: string
}

export const insightsLoad = (
  accountId: string,
  startDate?: string,
  endDate?: string
): InsightsLoadAction => ({
  type: INSIGHTS_LOAD,
  accountId,
  startDate,
  endDate
})

export const INSIGHTS_RELOAD = 'INSIGHTS_RELOAD'
export interface InsightsReloadAction {
  type: typeof INSIGHTS_RELOAD
  accountId: string
  startDate?: string
  endDate?: string
}

export const insightsReload = (
  accountId: string,
  startDate?: string,
  endDate?: string
): InsightsReloadAction => ({
  type: INSIGHTS_RELOAD,
  accountId,
  startDate,
  endDate
})

export const INSIGHTS_LOAD_SUCCESS = 'INSIGHTS_LOAD_SUCCESS'
export interface InsightsLoadSuccessAction {
  type: typeof INSIGHTS_LOAD_SUCCESS
  accountId: string
  insights: Report[]
}

export const insightsLoadSuccess = (accountId: string, insights: Report[]) => ({
  type: INSIGHTS_LOAD_SUCCESS,
  accountId,
  insights
})

export const INSIGHTS_LOAD_FAILURE = 'INSIGHTS_LOAD_FAILURE'
export interface InsightsLoadFailureAction {
  type: typeof INSIGHTS_LOAD_FAILURE
  accountId: string
  error: unknown
}

export const insightsLoadFailure = (accountId: string, error: unknown) => ({
  type: INSIGHTS_LOAD_FAILURE,
  accountId,
  error
})

export const INSIGHTS_RELOAD_SUCCESS = 'INSIGHTS_RELOAD_SUCCESS'
export interface InsightsReloadSuccessAction {
  type: typeof INSIGHTS_RELOAD_SUCCESS
  accountId: string
  insights: Report[]
}

export const insightsReloadSuccess = (
  accountId: string,
  insights: Report[]
) => ({
  type: INSIGHTS_RELOAD_SUCCESS,
  accountId,
  insights
})

export type InsightsAction =
  | InsightsLoadAction
  | InsightsReloadAction
  | InsightsLoadSuccessAction
  | InsightsLoadFailureAction
  | InsightsReloadSuccessAction
